export default "__VITE_ASSET__MBQHr6jB__"